import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Exclamation = forwardRef<SVGSVGElement, SvgIconProps>(
  function Exclamation(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <g>
          <path d="m11.99526,15.69615a1.95462,2.23308 0 0 1 -1.95699,-2.14365l-0.35107,-9.61798a1.95699,2.23579 0 0 1 1.95699,-2.33065l0.71163,0a1.95699,2.23579 0 0 1 1.95699,2.33065l-0.36056,9.61798a1.95462,2.23308 0 0 1 -1.95699,2.14365z" />
          <path d="m12,22.05668a1.65238,1.53111 0 1 1 1.65238,-1.53111a1.65238,1.53111 0 0 1 -1.65238,1.53111z" />
        </g>
      </SvgIcon>
    )
  },
)

export default Exclamation
